import {useEffect,useMemo,useRef,useState} from 'react';
import {useNavigate,useParams} from 'react-router-dom';
import {Layout} from '../components/Layout';
import {Button,Card} from '../components/ui';
import {api,ApiError} from '../lib/api';
import type {ApiResponse} from '../lib/types';
import controls from '../../../app/view/catalog-studio/studio.html?raw';
import script from '../../../app/view/catalog-studio/studio.js?raw';
// @ts-expect-error Shared, framework-independent document builder.
import {catalogStudioPage} from '../../../app/view/catalog-studio.js';

type Campaign={name:string;catalog_recommendation_id?:string|null};
export default function CampaignRecommendations(){
 const {id}=useParams(),navigate=useNavigate(),frame=useRef<HTMLIFrameElement>(null);
 const [campaign,setCampaign]=useState<Campaign|null>(null),[error,setError]=useState(''),[height,setHeight]=useState(1100);
 const channel=useMemo(()=>crypto.randomUUID(),[id]);
 useEffect(()=>{let current=true;setCampaign(null);setError('');api.get<ApiResponse<Campaign>>(`/campaigns/get?id=${encodeURIComponent(id||'')}`).then(r=>{
  if(!current)return;if(!r.data?.catalog_recommendation_id){setError('No recommendation strategy is linked to this campaign.');return;}setCampaign(r.data);
 }).catch(()=>{if(current)setError('Unable to load recommendations.');});return()=>{current=false;};},[id]);
 const document=useMemo(()=>campaign?catalogStudioPage({id:campaign.catalog_recommendation_id,name:campaign.name,channel,controls,script}):'',[campaign,channel]);
 useEffect(()=>{
  if(!campaign?.catalog_recommendation_id)return;
  const prefix=`/api/campaigns/${campaign.catalog_recommendation_id}/recommendations`;
  const receive=async(event:MessageEvent)=>{
   const message=event.data;if(event.source!==frame.current?.contentWindow||event.origin!=='null'||message?.channel!==channel)return;
   if(Number.isFinite(message.height)){setHeight(Math.max(600,Math.min(12000,message.height)));return;}
   if(!Number.isSafeInteger(message.id)||message.id<1||typeof message.path!=='string'||message.path.length>4000)return;
   let url:URL;try{url=new URL(message.path,'https://local.invalid');}catch{return;}
   const allowed=url.origin==='https://local.invalid'&&((url.pathname===prefix&&['GET','PUT'].includes(message.method))||(url.pathname===prefix+'/products'&&message.method==='GET')||(url.pathname===prefix+'/simulate'&&message.method==='POST'));
   if(!allowed)return;
   const source=event.source as Window;
   try{
    const path='/catalog-console'+url.pathname.slice(4)+url.search;
    const body=message.method==='GET'?await api.get(path):message.method==='PUT'?await api.put(path,JSON.parse(message.body)):await api.post(path,JSON.parse(message.body));
    source.postMessage({channel,id:message.id,body},'*');
   }catch(e){source.postMessage({channel,id:message.id,status:e instanceof ApiError?e.status:503,error:e instanceof Error?e.message:'Recommendations unavailable'},'*');}
  };
  window.addEventListener('message',receive);return()=>window.removeEventListener('message',receive);
 },[campaign,channel]);
 return <Layout title="Recommendations" actions={<Button variant="ghost" onClick={()=>navigate(`/campaigns/view/${id}`)}>← Back to campaign</Button>}>
  {error?<Card className="p-6 text-rose-400">{error}</Card>:!campaign?<Card className="p-6">Loading…</Card>:<iframe ref={frame} title="Recommendation Studio" sandbox="allow-scripts" srcDoc={document} style={{width:'100%',height,border:0,borderRadius:12}}/>}
 </Layout>;
}
